import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { Agreement } from "@modules/agreements/types";
import { Plan } from "@modules/plans/types";

export const useMapIntegrationPlanListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  mapintegrationplanModalRef: RefObject<ModalRef>,
  agreements: Agreement[] = [],
  plans: Plan[] = []
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "plan_slug_integration",
        headerName: translate("subscription_mapintegrationplan_admin.fields.plan_slug_integration"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text value={value} textAlign="left" />
        ),
      },
      {
        field: "agreement",
        headerName: translate("subscription_mapintegrationplan_admin.fields.agreement"),
        minWidth: 200,
        flex: 0.5,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/agreement/edit/${value}`}
            value={agreements?.find(agreement => agreement.id === value)?.name}
          />
        ),
      },
      {
        field: "product_name",
        headerName: translate("subscription_mapintegrationplan_admin.fields.product"),
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerAlign: "left",
        renderCell: ({ row }) =>
          row.agreement && row.product_name ? (
            <TableCell.Link
              to={`/agreement/edit/${row.agreement}?tab=products`}
              value={row.product_name}
            />
          ) : (
            <TableCell.Text value={row.product_name} textAlign="left" />
          ),
      },
      {
        field: "plan",
        headerName: translate("subscription_mapintegrationplan_admin.fields.plan"),
        minWidth: 200,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={plans?.find(plan => plan.id === value)?.name}
          />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => mapintegrationplanModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              resource="v1/subscription_mapintegrationplan_admin"
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, mapintegrationplanModalRef, agreements, plans]
  );
};
